<template>    
    <v-card color="#fff">
        <v-card-title>            
            <h1 class="display-5">{{ item.name }}</h1> </br>                
        </v-card-title>                                        
        <v-container grid-list-xs fill-height>
            <v-layout row wrap fill-height>
                <v-flex xs6>                    
                    <v-layout column>
                        <v-flex >
                            <p v-if="item.adress">
                                <b>{{item.adress.street}}</b> </br>                            
                                {{item.adress.zip}} {{item.adress.city}}                          
                            </p>
                            <p v-else>
                                <b>N.N</b> </br>                            
                                00000 N.N
                            </p>
                        </v-flex>
                        <v-flex>
                            <p>
                                <v-icon small class="mr-2">call</v-icon> {{item.phone}} <br>
                                <v-icon small class="mr-2">email</v-icon> {{item.email}}  <br>
                                <v-icon small class="mr-2">language</v-icon> {{item.web}}
                            </p>                                                                                                         
                        </v-flex>
                    </v-layout>              
                </v-flex>
                <v-flex d-flex xs2></v-flex>
                <v-flex d-flex xs4>
                    
                </v-flex>
            </v-layout>
        </v-container>

                        
        <v-card-actions class="grey darken-3 pt-0">
            
            <listactionbar v-on:actiontriggered="onAction" :item="item" :tileactions="tileactions"></listactionbar>
            
        </v-card-actions>  
                    
        
    </v-card>
</template>
<script>
    import listactionbar from './ListActionbar.vue'
    import { mapGetters } from 'vuex';    
    export default {   
    
    props: [
        'item',
        'tileactions',
        'paths'
    ],
    components: {
        listactionbar:listactionbar
    },
    data() {
        return {  
           
                    
        }
    },
    computed: {
        
        
    },
    methods: {
        onAction(action){
            
            if(action.link!=""){
                this.$router.push({name: action.link, params: {id: this.item.id}})
            } else {
                var r = confirm("remove image")
                if (r == true) {                
                    this.$store.dispatch('companies/deleteById',this.item.id)
                            .then(response=>{
                                this.setMessage('200','Erfolg. Die Firma wurde gelöscht')
                            }).catch(error=>{
                                this.setMessage(error.response.status,error.response.data)
                            })
                }else{                    
                }
            }
        }
    },
    
    
    
}
</script>
